// podcastPlayer.js

export function initPodcastPlayer(scope = document) {

    const root = typeof scope === "string"
        ? document.querySelector(scope)
        : scope;

    if (!root) return;

    const players = root.querySelectorAll(".audio-player");
    const allAudios = [];

    players.forEach(player => {

        const playerId = player.dataset.playerId;
        if (!playerId) {
            console.warn("Missing data-player-id on .audio-player");
            return;
        }

        const audio = player.querySelector("audio");
        const trackEl = player.querySelector("track");
        const toggleBtn = player.querySelector(".transcribe-button");
        const transcript = player.querySelector(".transcript");

        if (!audio || !trackEl || !toggleBtn || !transcript) return;

        allAudios.push(audio);

        let textTrack;
        let cues = [];
        let activeEl = null;
        let subtitlesEnabled = false;
        let isVisible = true;
        let userScrolling = false;
        let scrollTimeout;

        /* ---------------------------
           IntersectionObserver
        --------------------------- */
        const observer = new IntersectionObserver(entries => {
            isVisible = entries[0].isIntersecting;
        }, { threshold: 0.1 });

        observer.observe(player);

        /* ---------------------------
           Detect Manual Scroll
        --------------------------- */
        transcript.addEventListener("scroll", () => {
            userScrolling = true;
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                userScrolling = false;
            }, 1500);
        });

        /* ---------------------------
           Restore Toggle State
        --------------------------- */
        if (localStorage.getItem("subs-" + playerId) === "true") {
            enableSubs();
        }

        /* ---------------------------
           Track Loaded (robust)
        --------------------------- */
        audio.addEventListener("loadedmetadata", async () => {

            await new Promise(r => setTimeout(r, 50));

            textTrack = Array.from(audio.textTracks)
                .find(t => t.kind === "metadata");

            if (!textTrack) return;

            textTrack.mode = "hidden";

            const loadCues = () => {
                if (textTrack.cues && textTrack.cues.length > 0) {
                    cues = Array.from(textTrack.cues);
                    buildTranscript();
                    textTrack.addEventListener("cuechange", handleCueChange);
                    return true;
                }
                return false;
            };

            if (!loadCues()) {
                const interval = setInterval(() => {
                    if (loadCues()) clearInterval(interval);
                }, 50);
            }
        });

        function buildTranscript() {
            if (!cues || !cues.length) return;

            transcript.innerHTML = "";

            cues.forEach((cue, index) => {
                const div = document.createElement("div");
                div.className = "cue";
                div.textContent = cue.text;
                div.dataset.index = index;

                div.addEventListener("click", () => {
                    audio.currentTime = cue.startTime;
                });

                transcript.appendChild(div);
            });
        }

        function handleCueChange() {
            if (!subtitlesEnabled || !isVisible) return;

            const activeCue = textTrack.activeCues[0];
            if (!activeCue) return;

            const index = cues.indexOf(activeCue);
            const newEl = transcript.children[index];
            if (!newEl) return;

            if (activeEl) activeEl.classList.remove("active");

            activeEl = newEl;
            activeEl.classList.add("active");

            if (!audio.paused && !userScrolling) {
                activeEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }

        /* ---------------------------
           Toggle
        --------------------------- */
        toggleBtn.addEventListener("click", () => {
            subtitlesEnabled ? disableSubs() : enableSubs();
        });

        function enableSubs(setTrackMode = true) {
            subtitlesEnabled = true;
            transcript.style.display = "block";
            toggleBtn.classList.add("active");
            localStorage.setItem("subs-" + playerId, "true");

            // Only change native track mode if called by toggle
            if (textTrack && setTrackMode) textTrack.mode = "showing";
        }

        function disableSubs(setTrackMode = true) {
            subtitlesEnabled = false;
            transcript.style.display = "none";
            toggleBtn.classList.remove("active");
            localStorage.setItem("subs-" + playerId, "false");

            if (textTrack && setTrackMode) textTrack.mode = "hidden";
        }

        /* ---------------------------
           Auto Pause Others
        --------------------------- */
        audio.addEventListener("play", () => {
            allAudios.forEach(a => {
                if (a !== audio) a.pause();
            });
        });
    });

}